import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import FormControl from '@material-ui/core/FormControl'
import ArrowRightIcon from '@material-ui/icons/ArrowRight'
import HelpIcon from '@material-ui/icons/Help'
import CustomExpansionPanel from '../custom-material/expansion-panel/ExpansionPanel'
import { DarkCustomExpansionPanelActions } from '../custom-material/expansion-panel/ExpansionPanelActions'
import CustomExpansionPanelDetails from '../custom-material/expansion-panel/ExpansionPanelDetails'
import CustomFormControlLabel from '../custom-material/form-control-label/FormControlLabel'
import { SmallCustomSwitch } from '../custom-material/switch/Switch'
import { TitleCustomExpansionPanelSummary } from '../custom-material/expansion-panel/ExpansionPanelSummary'
import CustomTypography from '../custom-material/typography/Typography'
import EmptyStateComponent from '../common/empty-state/EmptyStateComponent'
import SuspendAllDialog from './SuspendAllDialog'
import HelpDialog from './HelpDialog'
import { getImage } from '../../libs/help'
import { isEmpty } from 'lodash'

const styles = theme => ({
  expansionPanelTitle: {
    fontSize: 22,
    fontWeight: 'normal',
    paddingRight: 0,
    display: 'flex',
    alignItems: 'center'
  },
  expansionPanelActions: {},
  formControlLabel: {
    display: 'flex',
    alignItems: 'center',
    marginTop: 4
  },
  disabledSwitch: {
    backgroundColor: '#C0C0C0 !important'
  },
  helpIcon: {
    marginLeft: -16,
    fontSize: 22,
    color: '#00ACEF',
    cursor: 'pointer'
  }
})

class WatchListAlertExpansionPanel extends React.PureComponent {
  constructor (props) {
    super(props)
    this.state = {
      suspendAllDialogOpen: false,
      helpDialogOpen: false,
      helpSelected: {
        id: '',
        name: ''
      }
    }

    this.openSuspendAllDialog = () => this.setState({suspendAllDialogOpen: true})
    this.handleCloseSuspendAllDialog = () => this.setState({suspendAllDialogOpen: false})
    this.openHelpDialog = (id, name) => () => this.setState({helpDialogOpen: true, helpSelected: {id, name}})
    this.handleCloseHelpDialog = () => this.setState({helpDialogOpen: false})
  }

  render () {
    const { classes, contact, exclusions, toggleExclusion, enableSuspendAll, disableSuspendAll, isAllWatchlistsSuspended: isAllSuspended } = this.props
    const { suspendAllDialogOpen, helpDialogOpen, helpSelected } = this.state    
    const filter_groups_filtered =
      exclusions && Array.isArray(exclusions.filter_groups)
        ? exclusions.filter_groups.filter(group => group && group.section === 'Weekly Publication')
        : [];



    return (
      <CustomExpansionPanel defaultExpanded>
        <TitleCustomExpansionPanelSummary expandIcon={<ArrowRightIcon style={{fontSize: 50}} />}>
          <CustomTypography className={classes.expansionPanelTitle}>Watch List Settings</CustomTypography>
        </TitleCustomExpansionPanelSummary>
        <CustomExpansionPanelDetails style={{paddingTop: 16, paddingBottom: 16}}>
          <React.Fragment>
            <FormControl component='fieldset' className={classes.formControl}>
              {isEmpty(filter_groups_filtered)
                ? <EmptyStateComponent title='No Watch List &amp; Database Alert Settings found' />
                : filter_groups_filtered.map((filterGroup, i) => (
                  <div key={filterGroup.id || filterGroup.name || i} style={{ display: 'flex', alignItems: 'center' }}>
                    <CustomFormControlLabel
                      label={
                        <span className={classes.formControlLabel}>
                          {filterGroup.name}&nbsp;
                        </span>
                      }
                      control={
                        <SmallCustomSwitch
                          classes={{track: filterGroup.filtered === null || isAllSuspended ? classes.disabledSwitch : ''}}
                          disableRipple
                          checked={filterGroup.filtered === false}
                          disabled={filterGroup.filtered === null || isAllSuspended}
                          onChange={toggleExclusion(filterGroup.name)}
                        />
                      }
                      />
                    {getImage(filterGroup.id) && <HelpIcon className={classes.helpIcon} onClick={this.openHelpDialog(filterGroup.id, filterGroup.name)} />}
                  </div>
              ))}
            </FormControl>
            {helpDialogOpen
              ? <HelpDialog
                dialogOpen={helpDialogOpen}
                handleCloseDialog={this.handleCloseHelpDialog}
                helpSelected={helpSelected}
                contact={contact}
              />
              : null
            }
          </React.Fragment>
        </CustomExpansionPanelDetails>
        <DarkCustomExpansionPanelActions className={classes.expansionPanelActions}>
          <FormControl component='fieldset' className={classes.formControl}>
            <CustomFormControlLabel
              label={<span className={classes.formControlLabel}>Suspend ALL Watch List &amp; Database Alerts</span>}
              control={
                <SmallCustomSwitch
                  disableRipple
                  checked={isAllSuspended}
                  onChange={isAllSuspended ? disableSuspendAll('Weekly Publication') : this.openSuspendAllDialog}
                />
              }
            />
          </FormControl>
          {suspendAllDialogOpen
            ? <SuspendAllDialog
              dialogOpen={suspendAllDialogOpen}
              handleCloseDialog={this.handleCloseSuspendAllDialog}
              suspendAll={enableSuspendAll}
              sectionName='Watch List &amp; Database Alerts'
              type='Weekly Publication'
            />
            : null
          }
        </DarkCustomExpansionPanelActions>
      </CustomExpansionPanel>
    )
  }
}

WatchListAlertExpansionPanel.propTypes = {
  classes: PropTypes.object.isRequired,
  contact: PropTypes.object,
  exclusions: PropTypes.object,
  toggleExclusion: PropTypes.func.isRequired,
  enableSuspendAll: PropTypes.func.isRequired,
  disableSuspendAll: PropTypes.func.isRequired,
  isAllWatchlistsSuspended: PropTypes.bool
}

export default withStyles(styles)(WatchListAlertExpansionPanel)
